'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthBitHeader = require('@narvar/nth-bit-header');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTheme = require('@narvar/nth-hook-theme');
var useIsMobile = require('../hooks/useIsMobile.js');
var ThemedHistory = require('./ThemedHistory.js');
var DeliveryHistory_module = require('./DeliveryHistory.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const DeliveryHistory = props => {
  const {
    featureName,
    history
  } = props;
  const isMobile = useIsMobile["default"]();
  const [isOpen, setIsOpen] = React.useState(!isMobile);
  const onToggle = React.useCallback(() => setIsOpen(prev => !prev), []);
  const {
    blockDeliveryStatusHideHistory,
    blockDeliveryStatusHistoryTitle,
    blockDeliveryStatusShowHistory
  } = nthHookTranslations.useTranslations();
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  React.useEffect(() => {
    setIsOpen(!isMobile);
  }, [isMobile]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: DeliveryHistory_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    },
    onClick: onToggle
  }, isOpen ? blockDeliveryStatusHideHistory : blockDeliveryStatusShowHistory), isOpen && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h3",
    featureName: featureName,
    containerCustomStyle: {
      marginTop: '1rem'
    }
  }, blockDeliveryStatusHistoryTitle), /*#__PURE__*/React__default["default"].createElement("ol", {
    style: {
      margin: 0,
      listStyle: 'none',
      padding: 0
    }
  }, history.map(event => /*#__PURE__*/React__default["default"].createElement(ThemedHistory["default"], {
    key: event.date || undefined,
    event: event,
    featureName: featureName
  })))));
};
var DeliveryHistory$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(DeliveryHistory, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['blockDeliveryStatusHideHistory', 'blockDeliveryStatusHistoryTitle', 'blockDeliveryStatusShowHistory']
});

exports["default"] = DeliveryHistory$1;
